import { ActGlo, ActAdh } from '../App_Data/ActionTypes';
import { estMembreCS } from '../App_Code/Utils';

const initialState = {
    Adh: ActGlo.EN_COURS_DE_CHARGEMENT,
    NumAutoCopSel: undefined,
    EstMembreCS: false,
};

function AdhStore(state = initialState, action) {
    switch (action.type) {
    case ActGlo.RESET_STORE:
        return initialState;
    case ActAdh.ADH_AJOUT:
        return {
            ...state,
            EstMembreCS: false,
            Adh: action.data,
        };
    case ActGlo.CHANGE_COP_SEL:
        return {
            ...state,
            NumAutoCopSel: action.data,
            EstMembreCS: state.Adh.LsCopExts && estMembreCS(state.Adh.LsCopExts, action.data),
        };
    case ActAdh.ADH_AVIS_ENVOYE:
        return {
            ...state,
            Adh: { ...state.Adh, PeutLaisserAvis: false },
        };
        case ActAdh.ADH_COMPRIS_AIDE:
            return {
                ...state,
                Adh: { ...state.Adh, PremiereCnx: false },
            };
    default:
        return state;
    }
}

export default AdhStore;



// WEBPACK FOOTER //
// ./src/Reducers/AdhStore.js